module.exports = __webpack_public_path__ + "static/img/keyWords.f50ea38.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/keyWords.png
// module id = jZ9X
// module chunks = 0